import { Link } from "react-router-dom";

const navigation = {
  main: [
    { name: 'Dashboard', href: '/' },
    { name: 'Support', href: '/support' },
    { name: 'Profile', href: '/profile' },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-gray-100">
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
        <nav aria-label="Footer" className="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6">
          {navigation.main.map((item) => (
            <Link key={item.name} to={item.href} className="text-gray-600 hover:text-gray-900">
              {item.name}
            </Link>
          ))}
        </nav>
        <p className="mt-10 text-center text-sm/6 text-gray-600">&copy; 2025 Fungistics, LLC.</p>
      </div>
    </footer>
  )
}

